import React, { ReactElement } from 'react'
import { Formik, Form } from 'formik'
import {
  TPaymentForm,
  PaymentFormState,
} from '@mindfulchefuk/features/GiftCards/interfaces'

import { giftCardPaymentSchema } from '@mindfulchefuk/features/GiftCards/validation'

import { PaymentDetails } from '@mindfulchefuk/features/GiftCards/components/PaymentDetails'

import { Stack } from '@mindfulchefuk/design-system'

import { AnonymousUserInputDetails } from '@mindfulchefuk/features/GiftCards/components/AnonymousUserInputDetails'
import { LoggedInUserTitle } from '@mindfulchefuk/features/GiftCards/components/LoggedInUserTitle'
import { PurchaseDetails } from '@mindfulchefuk/features/GiftCards/components/PurchaseDetails'

export const PaymentForm = ({
  amount,
  firstName,
  lastName,
  email,
  onSubmit,
  cardDetails,
  isLoggedInUser,
  redirectUrl,
  giftCardId,
  onSuccess,
  onFailure,
  on3dsError,
}: TPaymentForm): ReactElement => {
  const initialValues = isLoggedInUser
    ? { isLoggedInUser }
    : {
        lastName,
        firstName,
        email,
        confirmEmail: email,
      }

  return (
    <Formik
      enableReinitialize
      onSubmit={onSubmit}
      validationSchema={!isLoggedInUser ? giftCardPaymentSchema : null}
      initialValues={initialValues as PaymentFormState}
    >
      <Form>
        <Stack spacing={32}>
          {isLoggedInUser ? (
            <LoggedInUserTitle email={email} />
          ) : (
            <AnonymousUserInputDetails />
          )}
          <PurchaseDetails amount={amount} />
          <PaymentDetails
            redirectUrl={redirectUrl}
            giftCardId={giftCardId}
            onSuccess={onSuccess}
            onFailure={onFailure}
            on3dsError={on3dsError}
            cardDetails={cardDetails}
          />
        </Stack>
      </Form>
    </Formik>
  )
}
